export default {
  dashboard: () => import("/tmp/build_96f1cc98/apps/web/src/layouts/dashboard.vue").then(m => m.default || m),
  default: () => import("/tmp/build_96f1cc98/apps/web/src/layouts/default.vue").then(m => m.default || m)
}